import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import Select, { StylesConfig } from "react-select";

import { GET_VENDORS_FOR_REPORT } from "../../../../../Qurries";
import { CustomDropdownIndicator } from "../../../Settlement/Settlement";

export interface VendorOption {
  label: string;
  value: string;
  id: string;
}

interface VendorSelectProps {
  setSelectSchool: React.Dispatch<React.SetStateAction<string>>;
  setSchoolId: React.Dispatch<React.SetStateAction<string>>;
  menuIsOpen?: boolean;
  selectedVendor: VendorOption | null;
  onVendorSelect?: (vendor: VendorOption | null) => void;
}

function VendorDropdownSelect({ setSelectSchool, setSchoolId, menuIsOpen,selectedVendor,onVendorSelect  }: VendorSelectProps) {
  const [vendors, setVendors] = useState<VendorOption[]>();

  const { data, loading } = useQuery(GET_VENDORS_FOR_REPORT, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (data?.getVendorsForMerchantReport) {
      const fetchedVendors = data.getVendorsForMerchantReport.map((vendor: any) => ({
        label: vendor.name,
        value: vendor.name,
        id: vendor.vendor_id,
      }));
      setVendors(fetchedVendors);
    }
  }, [data]);

  const customStyles: StylesConfig<VendorOption> = {
    control: (base) => ({
      ...base,
      backgroundColor: "#F6F8FA",
      border: "1px solid #1B163B",
      borderRadius: "6px",
      minHeight: "15px",
      margin: 0,
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0px 0.5rem",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "200px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#1E1B59",
      fontSize: "12px",
    }),
  };

  return (
    <div className="w-full flex flex-col">
      <Select
        className="font-normal capitalize"
        closeMenuOnSelect={true}
        options={vendors}
        menuIsOpen={menuIsOpen}
        isLoading={loading}
        isMulti={false} 
        value={selectedVendor}
        components={{
          DropdownIndicator: CustomDropdownIndicator,
          IndicatorSeparator: () => null,
        }}
        onChange={(newValue, _actionMeta) => {
          const option = newValue as VendorOption | null;
          if (onVendorSelect) {
            onVendorSelect(option);
          }
          if (option) {
            setSelectSchool(option.label);
            setSchoolId(option.id);
          } else {
            setSelectSchool("");
            setSchoolId("");
          }
        }}
        placeholder="Select Vendor"
        styles={customStyles}
      />
    </div>
  );
}

export default VendorDropdownSelect;
